export default __webpack_public_path__ + "573355c3596917fa5eeb50013731a1c3.png";